// Define wsImport constants

module.exports = {
  SHOW_COMP: 'SHOW_COMP',
  IMPORT_FROM: 'IMPORT_FROM',
  UPDATE_EXTERNAL_APP: 'UPDATE_EXTERNAL_APP',
  ITEM_TO_BE_IMPORT: 'ITEM_TO_BE_IMPORT', // create ws according to this selection
  SAVE_IMPORT_DATA: 'SAVE_IMPORT_DATA',
  GIT_REPOSITORIES_DATA: 'GIT_REPOSITORIES_DATA',
  SAVE_REPOSITORIES_ERROR: 'SAVE_REPOSITORIES_ERROR',
  SAVE_REPOSITORIES_DATA: 'SAVE_REPOSITORIES_DATA',
  SAVE_REPOSITORIES_MULTIPLE_DATA: 'SAVE_REPOSITORIES_MULTIPLE_DATA',
  SET_PROJECT_DATA: 'SET_PROJECT_DATA',
  SAVE_PROJECT_MULTIPLE_DATA: 'SAVE_PROJECT_MULTIPLE_DATA',
  SAVE_SYNC_TASK: 'SAVE_SYNC_TASK',
  SWITCH_BASIC_JQL: 'SWITCH_BASIC_JQL',
  SAVE_INSTANCES: 'SAVE_INSTANCES',
  SET_SELECTED_INSTANCE: 'SET_SELECTED_INSTANCE',
  SET_IS_JQL: 'SET_IS_JQL',
  SET_WS_NAME: 'SET_WS_NAME'
};
